import { gql } from '@apollo/client';

export const PersonFullFragment = gql(`
    fragment PersonFullFragment on Person {
        __typename
        sys {
            id
        }
        firstName
        lastName
        profileImage {
            ...ImageWrapperFragment
        }
        jobTitle
        atAGlance
        atFosterMade
        beyondIntroductions
        bio
        email
        expertise
        jobTitle
        socialLinks
        testimonial
        funFactsCollection(limit:3) {
            items {
                __typename
                sys {
                    id
                }
                fact
                header
                link {
                    ...InternalPageLinkFragment
                }
            }
        }
    }
`);
